// extracted by mini-css-extract-plugin
module.exports = {"photos":"Media_photos__3aXtH","videos":"Media_videos__2LLS5","photo":"Media_photo__QlWFN","video":"Media_video__3lsxW","hover":"Media_hover__35qo1"};